import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  getJobViewUrl,
  JOB_FIELDS,
} from '../../../constants';

const actionCaller = ({
  setModalOpen,
  apiMethod,
  requestBody,
  setIsJobActionSuccess,
  history,
  location,
  showCallout,
  calloutMessage,
}) => {
  setModalOpen(false);

  apiMethod({ ...requestBody })
    .then((response) => {
      setIsJobActionSuccess(true);
      history.push({
        pathname: getJobViewUrl(response[JOB_FIELDS.ID]),
        search: location.search,
        state: {
          jobId: response[JOB_FIELDS.ID],
          jobStatus: response[JOB_FIELDS.STATUS],
        }
      });
      showCallout({
        message: <FormattedMessage
          id={`ui-task-list.callout.${calloutMessage}.job`}
          values={{ name: response[JOB_FIELDS.NAME] }}
        />
      });
    })
    .catch(() => {
      setIsJobActionSuccess(false);
      showCallout({
        type: 'error',
        message: <FormattedMessage id="ui-task-list.validation.communicationProblem" />,
      });
    });
};

const handleActionJob = ({
  history,
  location,
  showCallout,
  setIsJobActionSuccess,
}) => {
  return ({
    setModalOpen,
    apiMethod,
    requestBody,
    calloutMessage,
  }) => {
    return actionCaller({
      setModalOpen,
      apiMethod,
      requestBody,
      setIsJobActionSuccess,
      history,
      location,
      showCallout,
      calloutMessage,
    });
  };
};

export default handleActionJob;
